webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _auth = __webpack_require__(16);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _vue = __webpack_require__(65);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(66);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(63);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _ECharts = __webpack_require__(178);
	
	var _ECharts2 = _interopRequireDefault(_ECharts);
	
	__webpack_require__(109);
	
	__webpack_require__(116);
	
	__webpack_require__(121);
	
	__webpack_require__(130);
	
	var _Home = __webpack_require__(181);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Hprice = __webpack_require__(183);
	
	var _Hprice2 = _interopRequireDefault(_Hprice);
	
	var _Hdqty = __webpack_require__(180);
	
	var _Hdqty2 = _interopRequireDefault(_Hdqty);
	
	var _Htype = __webpack_require__(184);
	
	var _Htype2 = _interopRequireDefault(_Htype);
	
	var _Hpie = __webpack_require__(182);
	
	var _Hpie2 = _interopRequireDefault(_Hpie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.options.emulateJSON = true;
	_vue2.default.http.options.emulateHTTP = true;
	
	_vue2.default.component('chart', _ECharts2.default);
	
	_auth2.default.setOpenid('ocwMjv_FhbsJTkhUNhAU7koY64Ps');
	console.log('get openid:%s', _auth2.default.getOpenid());
	console.log('get community:%s', _auth2.default.getCm());
	console.log('get token:%s', _auth2.default.getToken());
	
	var Home = {
	  template: '\n    <div class="home">\n      <h2>Home</h2>\n      <p>hello</p>\n    </div>\n  '
	};
	
	var Parent = {
	  data: function data() {
	    return {
	      transitionName: 'slide-left'
	    };
	  },
	
	  watch: {
	    '$route': function $route(to, from) {
	      var toDepth = to.path.split('/').length;
	      var fromDepth = from.path.split('/').length;
	      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
	    }
	  },
	  template: '\n    <div class="parent">\n      <nav class="navbar navbar-default" role="navigation">\n        <div class="container-fluid">\n          <div class="navbar-header">\n            <router-link to="/main">\n              <img alt="Brand" height="30" src="http://alpha-go.tech/wiki/lib/exe/fetch.php?cache=&media=alphago:back.png">\n            </router-link>\n          </div>\n\n          <ul id="myTab" class="nav nav-pills " role="tablist">\n            <!--li role="presentation"><a href="/detail/" data-toggle="tab">\u6210\u4EA4\u4EF7\u683C</a></li>\n            <li role="presentation"><a href="/detail/qty" data-toggle="tab">\u6210\u4EA4\u91CF</a></li>\n            <li role="presentation"><a href="/detail/type" data-toggle="tab">\u6237\u578B\u5206\u5E03</a></li-->\n            <li><router-link to="/detail/">\u6210\u4EA4\u4EF7\u683C</router-link></li>\n            <li><router-link to="/detail/qty">\u6210\u4EA4\u91CF</router-link></li>\n            <li><router-link to="/detail/type">\u6237\u578B\u5206\u5E03</router-link></li>\n          </ul>\n\n        </div><!-- /.container-fluid -->\n      </nav>\n\n\n\n      <!--h2>Parent</h2>\n      <ul>\n        <li><router-link to="/detail">/detail</router-link></li>\n        <li><router-link to="/detail/price">/detail/price</router-link></li>\n        <li><router-link to="/detail/qty">/detail/qty</router-link></li>\n        <li><router-link to="/detail/type">/detail/type</router-link></li>\n      </ul-->\n      <transition :name="transitionName">\n        <router-view class="child-view"></router-view>\n      </transition>\n    </div>\n  '
	};
	
	var HomeParent = {
	  data: function data() {
	    return {
	      transitionName: 'slide-left'
	    };
	  },
	
	  watch: {
	    '$route': function $route(to, from) {
	      var toDepth = to.path.split('/').length;
	      var fromDepth = from.path.split('/').length;
	      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
	    }
	  },
	  template: '\n\n    <div class="parent">\n      <nav class="navbar navbar-default" role="navigation">\n        <div class="container-fluid">\n          <div class="navbar-header">\n            <div class="col-xs-2 header-img">\n              <p><!--img src="http://wx.qlogo.cn/mmopen/7zVkCbG3KV0noJgWcib1eGVvXMBf7zuSsHduTMAOr7Q7cX5EibxLGwSTUVqqFywRCYEb1vbAoAEnceq7mSNUJqNzA3OAPzdMvX/0" class="img-responsive img-circle" alt="Responsive image"--></p>\n            </div>\n            <div class="col-xs-4 header-text">\n              <p class="text-left bg-warning" id="head-username">{{name}}</p>\n              <p class="text-left text-warning bg-info" id="head-coin">100 \u94A2\u8E66</p>\n            </div>\n            <div class="col-xs-4"></div>\n            <div class="col-xs-2 header-coin-img">\n              <img src="http://alpha-go.tech/wiki/lib/exe/fetch.php?cache=&media=alphago:%E5%9B%BE%E8%A1%A8.png" class="img-responsive img-circle" alt="Responsive image">\n            </div>\n          </div>\n        </div>\n      </nav>\n      <transition :name="transitionName">\n        <router-view class="child-view"></router-view>\n      </transition>\n    </div>\n  '
	};
	
	var Default = { template: '<div class="default">default</div>' };
	var Foo = { template: '<div class="foo">foo</div>' };
	var Bar = { template: '<div class="bar">bar</div>' };
	
	var Users = {
	  template: '\n    <div>\n      <h2>Users</h2>\n      <router-view></router-view>\n    </div>\n  '
	};
	
	var User = { template: '<div>{{ $route.params.username }}</div>' };
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  base: __dirname,
	  routes: [{ path: '/home', component: Home }, { path: '/testmain', component: _Home2.default }, { path: '/main', component: HomeParent,
	    children: [{ path: '', component: _Home2.default }]
	  }, { path: '/detail', component: Parent,
	    children: [{ path: '', component: _Hprice2.default }, { path: 'qty', component: _Hdqty2.default }, { path: 'type', component: _Htype2.default }]
	  }, { path: '/users', component: Users,
	    children: [{ path: ':username', name: 'user', component: User }]
	  }, { path: '/parent', component: Parent,
	    children: [{ path: '', component: Foo }, { path: 'foo', component: Foo }, { path: 'bar', component: Bar }]
	  }, { path: '*', redirect: '/main' }]
	});
	
	new _vue2.default({
	  router: router,
	  template: '\n    <div id="app">\n      <!--h1>Transitions</h1>\n      <ul>\n        <li><router-link to="/">/</router-link></li>\n        <li><router-link to="/detail/">/detail/price</router-link></li>\n        <li><router-link to="/detail/qty">/detail/qty</router-link></li>\n        <li><router-link to="/detail/type">/detail/type</router-link></li>\n\n        <li><router-link :to="{ name: \'user\', params: { username: \'evan\' }, query: { foo: \'bar\' }}" exact>\n            /users/evan?foo=bar\n          </router-link></li>\n        <li><router-link to="/parent">/parent</router-link></li>\n        <li><router-link to="/parent/foo">/parent/foo</router-link></li>\n        <li><router-link to="/parent/bar">/parent/bar</router-link></li>\n      </ul-->\n      <transition name="fade" mode="out-in">\n        <router-view class="view"></router-view>\n      </transition>\n    </div>\n  '
	}).$mount('#app');
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },

/***/ 16:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  getCm: function getCm() {
	    console.log("get community:%s", localStorage.cm);
	    return localStorage.cm;
	  },
	  setCm: function setCm(cb) {
	    console.log("set community:%s", cb);
	    localStorage.cm = cb;
	  },
	  delCm: function delCm() {
	    console.log("delete community");
	    delete localStorage.cm;
	  },
	  getOpenid: function getOpenid() {
	    console.log("get openid:%s", localStorage.openid);
	    return localStorage.openid;
	  },
	  setOpenid: function setOpenid(cb) {
	    console.log("set openid:%s", cb);
	    localStorage.openid = cb;
	  },
	  delOpenId: function delOpenId() {
	    console.log("delete openid");
	    delete localStorage.openid;
	  },
	  login: function login(email, pass, cb) {
	    var _this = this;
	
	    cb = arguments[arguments.length - 1];
	    if (localStorage.token) {
	      if (cb) cb(true);
	      this.onChange(true);
	      return;
	    }
	    pretendRequest(email, pass, function (res) {
	      if (res.authenticated) {
	        localStorage.token = res.token;
	        if (cb) cb(true);
	        _this.onChange(true);
	      } else {
	        if (cb) cb(false);
	        _this.onChange(false);
	      }
	    });
	  },
	  getToken: function getToken() {
	    return localStorage.token;
	  },
	  logout: function logout(cb) {
	    delete localStorage.token;
	    if (cb) cb();
	    this.onChange(false);
	  },
	  loggedIn: function loggedIn() {
	    return !!localStorage.token;
	  },
	  onChange: function onChange() {}
	};
	
	
	function pretendRequest(email, pass, cb) {
	  setTimeout(function () {
	    if (email === 'joe@example.com' && pass === 'password1') {
	      cb({
	        authenticated: true,
	        token: Math.random().toString(36).substring(7)
	      });
	    } else {
	      cb({ authenticated: false });
	    }
	  }, 0);
	}

/***/ },

/***/ 20:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(60)
	
	/* script */
	__vue_exports__ = __webpack_require__(171)
	
	/* template */
	var __vue_template__ = __webpack_require__(190)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-716fdc1b"
	
	module.exports = __vue_exports__


/***/ },

/***/ 55:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 56:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 57:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 58:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 59:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 60:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 61:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 62:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 169:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(6);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _lodash = __webpack_require__(168);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTION_EVENTS = ['legendselectchanged', 'legendselected', 'legendunselected', 'datazoom', 'datarangeselected', 'timelinechanged', 'timelineplaychanged', 'restore', 'dataviewchanged', 'magictypechanged', 'geoselectchanged', 'geoselected', 'geounselected', 'pieselectchanged', 'pieselected', 'pieunselected', 'mapselectchanged', 'mapselected', 'mapunselected', 'axisareaselected', 'brush', 'brushselected'];
	
	var MOUSE_EVENTS = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousedown', 'mouseup', 'globalout'];
	
	exports.default = {
	  props: {
	    options: Object,
	    theme: String,
	    initOptions: Object,
	    group: String,
	    autoResize: Boolean
	  },
	  data: function data() {
	    return {
	      chart: null
	    };
	  },
	
	  computed: {
	    width: {
	      cache: false,
	      getter: function getter() {
	        return this.chart.getWidth();
	      }
	    },
	    height: {
	      cache: false,
	      getter: function getter() {
	        return this.chart.getHeight();
	      }
	    },
	    isDisposed: {
	      cache: false,
	      getter: function getter() {
	        return this.chart.isDisposed();
	      }
	    }
	  },
	  watch: {
	    options: {
	      handler: function handler(options) {
	        this.chart.setOption(options, true);
	      },
	
	      deep: true
	    },
	    group: {
	      handler: function handler(group) {
	        this.chart.group = group;
	      }
	    }
	  },
	  methods: {
	    mergeOptions: function mergeOptions(options) {
	      this.chart.setOption(options);
	    },
	    resize: function resize(options) {
	      this.chart.resize(options);
	    },
	    dispatchAction: function dispatchAction(payload) {
	      this.chart.dispatchAction(payload);
	    },
	    convertToPixel: function convertToPixel() {
	      var _chart;
	
	      return (_chart = this.chart).convertToPixel.apply(_chart, arguments);
	    },
	    convertFromPixel: function convertFromPixel() {
	      var _chart2;
	
	      return (_chart2 = this.chart).convertFromPixel.apply(_chart2, arguments);
	    },
	    containPixel: function containPixel() {
	      var _chart3;
	
	      return (_chart3 = this.chart).containPixel.apply(_chart3, arguments);
	    },
	    showLoading: function showLoading() {
	      var _chart4;
	
	      (_chart4 = this.chart).showLoading.apply(_chart4, arguments);
	    },
	    hideLoading: function hideLoading() {
	      this.chart.hideLoading();
	    },
	    getDataURL: function getDataURL(options) {
	      return this.chart.getDataURL(options);
	    },
	    getConnectedDataURL: function getConnectedDataURL(options) {
	      return this.chart.getConnectedDataURL(options);
	    },
	    clear: function clear() {
	      this.chart.clear();
	    },
	    dispose: function dispose() {
	      this.chart.dispose();
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var chart = _echarts2.default.init(this.$el, this.theme, this.initOptions);
	
	    chart.setOption(this.options);
	
	    ACTION_EVENTS.forEach(function (event) {
	      chart.on(event, function (params) {
	        _this.$emit(event, params);
	      });
	    });
	
	    MOUSE_EVENTS.forEach(function (event) {
	      chart.on(event, function (params) {
	        _this.$emit('chart' + event, params);
	      });
	    });
	
	    if (this.autoResize) {
	      this.__resizeHanlder = (0, _lodash2.default)(function () {
	        chart.resize();
	      }, 100, { leading: true });
	      window.addEventListener('resize', this.__resizeHanlder);
	    }
	
	    this.chart = chart;
	  },
	  connect: function connect(group) {
	    if (typeof group !== 'string') {
	      group = group.map(function (chart) {
	        return chart.chart;
	      });
	    }
	    _echarts2.default.connect(group);
	  },
	  disconnect: function disconnect(group) {
	    _echarts2.default.disconnect(group);
	  },
	  registerMap: function registerMap() {
	    _echarts2.default.registerMap.apply(_echarts2.default, arguments);
	  },
	  registerTheme: function registerTheme() {
	    _echarts2.default.registerTheme.apply(_echarts2.default, arguments);
	  }
	};

/***/ },

/***/ 170:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(177);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    href: String,
	    required: true
	  },
	  computed: {
	    isActive: function isActive() {
	      return this.href === this.$root.currentRoute;
	    }
	  },
	  methods: {
	    go: function go(event) {
	      event.preventDefault();
	      this.$root.currentRoute = this.href;
	      window.history.pushState(null, _routes2.default[this.href], this.href);
	    }
	  }
	};

/***/ },

/***/ 171:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VLink = __webpack_require__(179);
	
	var _VLink2 = _interopRequireDefault(_VLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    VLink: _VLink2.default
	  }
	};

/***/ },

/***/ 172:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(20);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _auth = __webpack_require__(16);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log("auth:%o", _auth2.default);
	
	exports.default = {
	  data: function data() {
	    var legend_data = ['1', '2', '3', '4', '5'];
	    var series_data = [{ "value": "154", "name": "1" }, { "value": "576", "name": "2" }, { "value": "70", "name": "3" }, { "value": "12", "name": "4" }, { "value": "2", "name": "5" }];
	
	    return {
	
	      openid: '',
	      token: '',
	      community: '',
	      reqHouseAreaUrl: 'https://alphago.chemucao.cn/real/index.php/community/deal?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&community=',
	      respData: {},
	
	      line: {
	        title: {
	          text: '成交价格',
	          left: 'center',
	          textStyle: {
	            color: '#999'
	          }
	        },
	        tooltip: {
	          trigger: 'axis'
	        },
	        legend: {
	          top: 25,
	          data: ['phpdata', '北京']
	        },
	        grid: {
	          left: '3%',
	          right: '4%',
	          bottom: '3%',
	          containLabel: true
	        },
	        toolbox: {
	          feature: {
	            dataZoom: { yAxisIndex: 'none' },
	            dataView: { readOnly: false },
	            saveAsImage: {}
	          }
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: true,
	          data: []
	        },
	        yAxis: {
	          type: 'value'
	        },
	        series: [{
	          name: 'phpdata',
	          type: 'line',
	          data: ['phpdata']
	        }, {
	          name: '北京',
	          type: 'line',
	          data: ['phpdata']
	        }]
	      },
	
	      bar: {
	        title: {
	          text: '成交数量',
	          left: 'center',
	          textStyle: {
	            color: '#999'
	          }
	        },
	        tooltip: {
	          trigger: 'axis'
	        },
	        legend: {
	          top: 25,
	          data: ['phpdata', '北京']
	        },
	        grid: {
	          left: '3%',
	          right: '4%',
	          bottom: '3%',
	          containLabel: true
	        },
	        toolbox: {
	          feature: {
	            dataZoom: { yAxisIndex: 'none' },
	            dataView: { readOnly: false },
	            saveAsImage: {}
	          }
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: true,
	          data: ['phpdata']
	        },
	        yAxis: {
	          type: 'value'
	        },
	        series: [{
	          name: 'phpdata',
	          type: 'bar',
	          data: ['phpdata']
	        }, {
	          name: '北京',
	          type: 'bar',
	          data: ['phpdata']
	        }]
	      }
	
	    };
	  },
	
	  methods: {
	    load: function load() {
	      console.log("this.respData:%o", this.respData);
	
	      var count = this.respData.count;
	
	      var bj_count = this.respData.bj_count;
	
	      var brief = this.respData.brief;
	
	      console.log("updateChart...count:%o", count);
	      var at = [];
	      var as = [];
	      for (var key in count) {
	        var value = count[key];
	        at.push(key);
	        as.push(value);
	      }
	
	      console.log("updateChart...bj_count:%o", bj_count);
	      var bat = [];
	      var bas = [];
	      for (var _key in bj_count) {
	        var _value = bj_count[_key];
	        bat.push(_key);
	        bas.push(_value);
	      }
	
	      var n = [];
	      n.push(brief.name);
	      n.push("北京");
	      console.log("n:%o", n);
	      var asyncData = {
	        name: n,
	        categories: at,
	        data: as
	      };
	
	      var bjasyncData = {
	        categories: bat,
	        data: bas
	      };
	
	      console.log("load...asyncData:%o", asyncData.data);
	      console.log("load...bjasyncData:%o", bjasyncData.data);
	
	      this.$refs.bar.mergeOptions({
	        legend: {
	          top: 25,
	          data: asyncData.name
	        },
	        xAxis: {
	          data: asyncData.categories
	        },
	        series: [{
	          name: asyncData.name[0],
	          data: asyncData.data
	        }, {
	          name: "北京",
	          data: bjasyncData.data
	        }]
	      });
	    },
	
	    reqApiData: function reqApiData(community) {
	      var _this = this;
	
	      console.info("community:%s", community);
	      var url = this.reqHouseAreaUrl + community;
	      console.debug("reqHouseArea url:%s", url);
	
	      this.$http.post(url, { foo: "bar" }).then(function (response) {
	        console.info("PASS! response:%o", response);
	        console.log("status%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body);
	        _this.respData = response.body.data;
	        _this.load();
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    },
	    updateChart: function updateChart(data) {
	      data = [{ "count": "154", "bedroom": "1" }, { "count": "576", "bedroom": "2" }, { "count": "70", "bedroom": "3" }, { "count": "12", "bedroom": "4" }, { "count": "2", "bedroom": "5" }];
	      console.log("updateChart...data:%o", data);
	      var at = new Array();
	      var as = new Array();
	      var asyncData = {
	        categories: at,
	        data: as
	      };
	
	      for (var x in data) {
	        console.log("x:%s, data:%o", x, data[x]);
	        var tn = data[x]["bedroom"] + "居室";
	        at.push(tn);
	        var ass = '{"value":"' + data[x]["count"] + '","name":"' + tn + '"}';
	        as.push(ass);
	      }
	      console.log("at:%o, as:%o", at, as);
	      console.log("this.$refs.pie:%o", this.$refs.pie);
	
	      return asyncData;
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    console.log("beforeCreate...");
	  },
	  created: function created() {
	    console.log("created...");
	    console.log('get openid:%s', _auth2.default.getOpenid());
	    console.log('get community:%s', _auth2.default.getCm());
	    console.log('get token:%s', _auth2.default.getToken());
	    this.community = _auth2.default.getCm();
	    console.log("community:%s", this.community);
	    this.reqApiData(this.community);
	  },
	  beforeMount: function beforeMount() {
	    console.log("beforeMount...");
	  },
	  mounted: function mounted() {
	    console.log("mounted...");
	  },
	  beforeUpdate: function beforeUpdate() {
	    console.log("beforeUpdate...");
	  },
	  updated: function updated() {
	    console.log("updated...");
	  },
	  activated: function activated() {
	    console.log("activated...");
	  },
	  deactivated: function deactivated() {
	    console.log("deactivated...");
	  },
	  beforeDestory: function beforeDestory() {
	    console.log("beforeDestory...");
	  },
	  destroyed: function destroyed() {
	    console.log("destroyed...");
	  },
	
	  components: {
	    MainLayout: _Main2.default
	  }
	
	};

/***/ },

/***/ 173:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(20);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _weixinJsSdk = __webpack_require__(64);
	
	var _weixinJsSdk2 = _interopRequireDefault(_weixinJsSdk);
	
	var _auth = __webpack_require__(16);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log("wx:%o", _weixinJsSdk2.default);
	
	console.log("auth:%o", _auth2.default);
	
	exports.default = {
	  data: function data() {
	    return {
	      titleMsg: '',
	      subtitleMsg: '你可能感兴趣的小区',
	      lists: ["上地国际创业园", "上地南路6号院", "上地东里", "上地西里"],
	      gridData: [],
	      coins: 100,
	      name: "Crowxjy",
	
	      apiUrl: 'http://localhost/test/api/',
	      reqHouseAreaUrl: 'https://alphago.chemucao.cn/real/index.php/community/deal?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&community=',
	      reqWxJSSignUrl: 'https://alphago.chemucao.cn/real/index.php/jsapi/sign?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&url=',
	      reqWxPaySignUrl: 'https://alphago.chemucao.cn/real/index.php/wxpay/launch?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&money=101',
	
	      wx_appId: "",
	      wx_timestamp: "",
	      wx_nonceStr: "",
	      wx_signature: "",
	
	      wxp_nonceStr: "",
	      wxp_package: "",
	      wxp_paySign: "",
	      wxp_signType: "",
	      wxp_timeStamp: "",
	
	      testUrl: 'http://jsonplaceholder.typicode.com/posts',
	      testData: {
	        "code": 10,
	        "msg": "not found",
	        "data": {
	          "guess": [{
	            "name": "上地国际创业园"
	          }, {
	            "name": "上地南路6号院"
	          }, {
	            "name": "上地东里"
	          }, {
	            "name": "上地西里"
	          }]
	        }
	      },
	
	      token: 'alphago_admin_debug',
	      openid: 'ocwMjv_FhbsJTkhUNhAU7koY64Ps',
	      community: ''
	    };
	  },
	  mounted: function mounted() {
	    console.info("mounted");
	
	    this.reqHouseArea(this.community);
	  },
	  created: function created() {
	    console.info("created currentRoute:%o", this.$root.currentRoute);
	    this.reqWxJSSign();
	  },
	
	  methods: {
	    submit: function submit() {
	      console.debug("submit community:%s", this.community);
	      this.reqHouseArea(this.community);
	      _auth2.default.setCm(this.community);
	    },
	    updateCm: function updateCm(cm) {
	      console.debug("update cm:%s", cm);
	      _auth2.default.setCm(cm);
	    },
	
	    updateValue: function updateValue(community) {
	      console.debug("updateValue:%s", this.community);
	    },
	    getBookLists: function getBookLists() {
	      console.debug("getBookLists");
	      this.$http.get(this.apiUrl).then(function (response) {
	        console.info("PASS! response:%o", response);
	        console.log("status%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body.results);
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    },
	
	    regWxJsApi: function regWxJsApi() {
	      console.debug("regWxJsApi");
	
	      _weixinJsSdk2.default.config({
	        debug: true,
	        appId: this.wx_appId,
	        timestamp: this.wx_timestamp,
	        nonceStr: this.wx_nonceStr,
	        signature: this.wx_signature,
	        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'],
	        success: function success(res) {
	          console.info("config successful!" + res);
	        },
	        error: function error(json) {
	          console.error("config failed:" + json);
	        }
	      });
	    },
	    regWxPay: function regWxPay() {
	      console.debug("regWxPay");
	
	      _weixinJsSdk2.default.chooseWXPay({
	        debug: true,
	        timestamp: this.wxp_timeStamp,
	        nonceStr: this.wxp_nonceStr,
	        package: this.wxp_package,
	        signType: this.wxp_signType,
	        paySign: this.wxp_paySign,
	        success: function success(res) {
	          console.info("pay successful!" + res);
	        },
	        error: function error(json) {
	          console.error("pay failed:" + json);
	        }
	      });
	    },
	    reqWxJSSign: function reqWxJSSign() {
	      var _this = this;
	
	      var local_url = location.href.split('#')[0];
	
	      var url = this.reqWxJSSignUrl + local_url;
	
	      this.$http.post(url, { foo: "bar" }).then(function (response) {
	        var dl = response.body.data;
	        _this.wx_appId = dl.appId;
	        _this.wx_timestamp = dl.timestamp;
	        _this.wx_nonceStr = dl.nonceStr;
	        _this.wx_signature = dl.signature;
	
	        _this.regWxJsApi();
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    },
	    reqWxPaySign: function reqWxPaySign() {
	      var _this2 = this;
	
	      var url = this.reqWxPaySignUrl;
	
	      this.$http.post(url, { foo: "bar" }).then(function (response) {
	        var dl = response.body.data;
	        _this2.wxp_nonceStr = dl.nonceStr, _this2.wxp_package = dl.package, _this2.wxp_paySign = dl.paySign, _this2.wxp_signType = dl.signType, _this2.wxp_timeStamp = dl.timeStamp, _this2.regWxPay();
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    },
	    reqHouseArea: function reqHouseArea(community) {
	      var _this3 = this;
	
	      console.info("community:%s", community);
	      var url = this.reqHouseAreaUrl + community;
	      console.debug("reqHouseArea url:%s", url);
	
	      this.$http.post(url, { foo: "bar" }).then(function (response) {
	        var datalist = response.body.data.guess;
	
	        var od = [];
	
	        for (var p in datalist) {
	          od.push(datalist[p]["name"]);
	        }
	
	        _this3.lists = od;
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    }
	  },
	  components: {
	    MainLayout: _Main2.default
	  }
	};

/***/ },

/***/ 174:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(20);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _auth = __webpack_require__(16);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log("auth:%o", _auth2.default);
	
	exports.default = {
	  data: function data() {
	    var legend_data = ['1', '2', '3', '4', '5'];
	    var series_data = [{ "value": "154", "name": "1" }, { "value": "576", "name": "2" }, { "value": "70", "name": "3" }, { "value": "12", "name": "4" }, { "value": "2", "name": "5" }];
	
	    return {
	
	      openid: '',
	      token: '',
	      community: '',
	      reqHouseAreaUrl: 'http://alphago.chemucao.cn/real/index.php/community/deal?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&community=',
	      respData: { "brief": { "id": "2225", "name": '\u5BCC\u529B\u53C8\u4E00\u57CEC\u533A', "code": "1111027374303", "district": '\u671D\u9633', "bizcycle": '\u8C46\u5404\u5E84', "subway": "", "school": "", "link": "http:\/\/bj.lianjia.com\/xiaoqu\/1111027374303\/", "crawl": "1" }, "price": { "2012-01": 18651, "2012-02": 17529, "2012-03": 18867, "2012-04": 19177, "2012-05": 19029, "2012-06": 19749, "2012-07": 21164, "2012-08": 20629, "2012-09": 20775, "2012-10": 20743, "2012-11": 21334, "2012-12": 22820, "2013-01": 24564, "2013-02": 25208, "2013-03": 25751, "2013-04": 26203, "2013-05": 25440, "2013-06": 26138, "2013-07": 27368, "2013-08": 28528, "2013-09": 28070, "2013-10": 31169, "2013-11": 32234, "2013-12": 30627, "2014-01": 28106, "2014-02": 32686, "2014-03": 17059, "2014-04": 28728, "2014-05": 28283, "2014-06": 17220, "2014-07": 27299, "2014-08": 28903, "2014-09": 27930, "2014-10": 27820, "2014-11": 25681, "2014-12": 26122, "2015-01": 27133, "2015-02": 18210, "2015-03": 26009, "2015-04": 26527, "2015-05": 26383, "2015-06": 26843, "2015-07": 27790, "2015-08": 27329, "2015-09": 26213, "2015-10": 30293, "2015-11": 31336, "2015-12": 30670, "2016-01": 29522, "2016-02": 32475, "2016-03": 36420, "2016-04": 33336, "2016-05": 32438, "2016-06": 39905, "2016-07": 41910, "2016-08": 42723, "2016-09": 52324, "2016-10": 48013, "2016-11": 46574, "2016-12": 52019 }, "count": { "2012-01": "3", "2012-02": "10", "2012-03": "8", "2012-04": "2", "2012-05": "6", "2012-06": "13", "2012-07": "4", "2012-08": "8", "2012-09": "7", "2012-10": "3", "2012-11": "10", "2012-12": "12", "2013-01": "14", "2013-02": "12", "2013-03": "10", "2013-04": "4", "2013-05": "7", "2013-06": "10", "2013-07": "7", "2013-08": "9", "2013-09": "5", "2013-10": "7", "2013-11": "2", "2013-12": "5", "2014-01": "7", "2014-02": "8", "2014-03": "2", "2014-04": "5", "2014-05": "2", "2014-06": "4", "2014-07": "2", "2014-08": "6", "2014-09": "2", "2014-10": "12", "2014-11": "5", "2014-12": "5", "2015-01": "4", "2015-02": "4", "2015-03": "13", "2015-04": "26", "2015-05": "18", "2015-06": "20", "2015-07": "25", "2015-08": "24", "2015-09": "18", "2015-10": "16", "2015-11": "18", "2015-12": "25", "2016-01": "26", "2016-02": "20", "2016-03": "16", "2016-04": "10", "2016-05": "11", "2016-06": "14", "2016-07": "22", "2016-08": "28", "2016-09": "12", "2016-10": "4", "2016-11": "7", "2016-12": "5" }, "bedroom": [{ "count": "154", "bedroom": "1" }, { "count": "576", "bedroom": "2" }, { "count": "70", "bedroom": "3" }, { "count": "12", "bedroom": "4" }, { "count": "2", "bedroom": "5" }], "bj_price": { "2012-01": 21839, "2012-02": 22211, "2012-03": 23095, "2012-04": 24041, "2012-05": 24647, "2012-06": 25361, "2012-07": 26366, "2012-08": 26898, "2012-09": 27274, "2012-10": 27332, "2012-11": 28157, "2012-12": 29133, "2013-01": 30690, "2013-02": 32003, "2013-03": 33865, "2013-04": 33133, "2013-05": 34367, "2013-06": 35303, "2013-07": 36181, "2013-08": 36864, "2013-09": 37670, "2013-10": 37891, "2013-11": 38804, "2013-12": 38340, "2014-01": 37917, "2014-02": 39504, "2014-03": 39241, "2014-04": 39384, "2014-05": 37713, "2014-06": 35984, "2014-07": 35823, "2014-08": 35346, "2014-09": 35017, "2014-10": 37112, "2014-11": 36586, "2014-12": 36712, "2015-01": 36589, "2015-02": 36359, "2015-03": 36723, "2015-04": 38059, "2015-05": 38556, "2015-06": 37368, "2015-07": 38381, "2015-08": 38841, "2015-09": 39495, "2015-10": 39595, "2015-11": 39742, "2015-12": 40617, "2016-01": 42047, "2016-02": 42198, "2016-03": 44460, "2016-04": 45728, "2016-05": 46748, "2016-06": 47373, "2016-07": 49900, "2016-08": 53037, "2016-09": 58526, "2016-10": 59899, "2016-11": 60644, "2016-12": 64706 }, "bj_count": { "2012-01": 870, "2012-02": 2792, "2012-03": 3364, "2012-04": 2994, "2012-05": 3549, "2012-06": 4238, "2012-07": 3834, "2012-08": 3150, "2012-09": 3010, "2012-10": 3513, "2012-11": 4113, "2012-12": 5526, "2013-01": 4867, "2013-02": 2595, "2013-03": 7342, "2013-04": 1952, "2013-05": 3135, "2013-06": 3340, "2013-07": 3207, "2013-08": 4104, "2013-09": 3934, "2013-10": 3180, "2013-11": 2399, "2013-12": 2691, "2014-01": 2325, "2014-02": 1703, "2014-03": 2472, "2014-04": 2153, "2014-05": 1912, "2014-06": 2240, "2014-07": 2765, "2014-08": 3296, "2014-09": 2687, "2014-10": 6077, "2014-11": 4099, "2014-12": 3593, "2015-01": 3778, "2015-02": 2142, "2015-03": 6322, "2015-04": 7241, "2015-05": 6771, "2015-06": 6687, "2015-07": 6264, "2015-08": 6441, "2015-09": 5154, "2015-10": 5794, "2015-11": 6965, "2015-12": 9828, "2016-01": 9437, "2016-02": 7164, "2016-03": 12288, "2016-04": 6240, "2016-05": 6605, "2016-06": 6906, "2016-07": 9472, "2016-08": 12702, "2016-09": 11126, "2016-10": 3659, "2016-11": 4319, "2016-12": 3216 }, "bj_bedroom": [{ "count": "21987", "bedroom": "" }, { "count": "78", "bedroom": "--" }, { "count": "43", "bedroom": "0" }, { "count": "92937", "bedroom": "1" }, { "count": "178924", "bedroom": "2" }, { "count": "74127", "bedroom": "3" }, { "count": "8087", "bedroom": "4" }, { "count": "1133", "bedroom": "5" }, { "count": "218", "bedroom": "6" }, { "count": "29", "bedroom": "7" }, { "count": "14", "bedroom": "8" }, { "count": "6", "bedroom": "9" }] },
	
	      bar: {
	        title: {
	          text: '异步数据加载示例'
	        },
	        tooltip: {},
	        legend: {
	          data: ['销量']
	        },
	        xAxis: {
	          data: []
	        },
	        yAxis: {},
	        series: [{
	          name: '销量',
	          type: 'bar',
	          data: []
	        }]
	      },
	
	      line: {
	        title: {
	          text: '成交价格',
	          left: 'center',
	          textStyle: {
	            color: '#999'
	          }
	        },
	        tooltip: {
	          trigger: 'axis'
	        },
	        legend: {
	          top: 25,
	          data: ['目标小区', '北京']
	        },
	        grid: {
	          left: '3%',
	          right: '4%',
	          bottom: '3%',
	          containLabel: true
	        },
	        toolbox: {
	          feature: {
	            dataZoom: { yAxisIndex: 'none' },
	            dataView: { readOnly: false },
	            saveAsImage: {}
	          }
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: true,
	          data: []
	        },
	        yAxis: {
	          type: 'value'
	        },
	        series: [{
	          name: '',
	          type: 'line',
	          data: []
	        }, {
	          name: '北京',
	          type: 'line',
	          data: []
	        }]
	      }
	
	    };
	  },
	
	  methods: {
	    load: function load() {
	      var price = { "2012-01": 18651, "2012-02": 17529, "2012-03": 18867, "2012-04": 19177, "2012-05": 19029, "2012-06": 19749, "2012-07": 21164, "2012-08": 20629, "2012-09": 20775, "2012-10": 20743, "2012-11": 21334, "2012-12": 22820, "2013-01": 24564, "2013-02": 25208, "2013-03": 25751, "2013-04": 26203, "2013-05": 25440, "2013-06": 26138, "2013-07": 27368, "2013-08": 28528, "2013-09": 28070, "2013-10": 31169, "2013-11": 32234, "2013-12": 30627, "2014-01": 28106, "2014-02": 32686, "2014-03": 17059, "2014-04": 28728, "2014-05": 28283, "2014-06": 17220, "2014-07": 27299, "2014-08": 28903, "2014-09": 27930, "2014-10": 27820, "2014-11": 25681, "2014-12": 26122, "2015-01": 27133, "2015-02": 18210, "2015-03": 26009, "2015-04": 26527, "2015-05": 26383, "2015-06": 26843, "2015-07": 27790, "2015-08": 27329, "2015-09": 26213, "2015-10": 30293, "2015-11": 31336, "2015-12": 30670, "2016-01": 29522, "2016-02": 32475, "2016-03": 36420, "2016-04": 33336, "2016-05": 32438, "2016-06": 39905, "2016-07": 41910, "2016-08": 42723, "2016-09": 52324, "2016-10": 48013, "2016-11": 46574, "2016-12": 52019 };
	
	      var bj_price = { "2012-01": 21839, "2012-02": 22211, "2012-03": 23095, "2012-04": 24041, "2012-05": 24647, "2012-06": 25361, "2012-07": 26366, "2012-08": 26898, "2012-09": 27274, "2012-10": 27332, "2012-11": 28157, "2012-12": 29133, "2013-01": 30690, "2013-02": 32003, "2013-03": 33865, "2013-04": 33133, "2013-05": 34367, "2013-06": 35303, "2013-07": 36181, "2013-08": 36864, "2013-09": 37670, "2013-10": 37891, "2013-11": 38804, "2013-12": 38340, "2014-01": 37917, "2014-02": 39504, "2014-03": 39241, "2014-04": 39384, "2014-05": 37713, "2014-06": 35984, "2014-07": 35823, "2014-08": 35346, "2014-09": 35017, "2014-10": 37112, "2014-11": 36586, "2014-12": 36712, "2015-01": 36589, "2015-02": 36359, "2015-03": 36723, "2015-04": 38059, "2015-05": 38556, "2015-06": 37368, "2015-07": 38381, "2015-08": 38841, "2015-09": 39495, "2015-10": 39595, "2015-11": 39742, "2015-12": 40617, "2016-01": 42047, "2016-02": 42198, "2016-03": 44460, "2016-04": 45728, "2016-05": 46748, "2016-06": 47373, "2016-07": 49900, "2016-08": 53037, "2016-09": 58526, "2016-10": 59899, "2016-11": 60644, "2016-12": 64706 };
	
	      var brief = { "id": "2225", "name": '\u5BCC\u529B\u53C8\u4E00\u57CEC\u533A', "code": "1111027374303", "district": '\u671D\u9633', "bizcycle": '\u8C46\u5404\u5E84', "subway": "", "school": "", "link": "http:\/\/bj.lianjia.com\/xiaoqu\/1111027374303\/", "crawl": "1" };
	
	      console.log("updateChart...price:%o", price);
	      var at = [];
	      var as = [];
	      for (var key in price) {
	        var value = price[key];
	        at.push(key);
	        as.push(price[key]);
	      }
	
	      var bat = [];
	      var bas = [];
	      for (var _key in bj_price) {
	        var _value = bj_price[_key];
	        bat.push(_key);
	        bas.push(bj_price[_key]);
	      }
	
	      var n = [];
	      n.push(brief.name);
	      n.push("北京");
	      console.log("n:%o", n);
	      var asyncData = {
	        name: n,
	        categories: at,
	        data: as
	      };
	
	      var bjasyncData = {
	        categories: bat,
	        data: bas
	      };
	
	      console.log("load...asyncData:%o", asyncData.data);
	      console.log("load...bjasyncData:%o", bjasyncData.data);
	
	      this.$refs.line.mergeOptions({
	        legend: {
	          top: 25,
	          data: asyncData.name
	        },
	        xAxis: {
	          data: asyncData.categories
	        },
	        series: [{
	          name: asyncData.name[0],
	          data: asyncData.data
	        }, {
	          name: "北京",
	          data: bjasyncData.data
	        }]
	      });
	    },
	
	    reqApiData: function reqApiData(community) {
	      console.info("community:%s", community);
	      var url = this.reqHouseAreaUrl + community;
	      console.debug("reqHouseArea url:%s", url);
	
	      this.$http.post(url, { foo: "bar" }).then(function (response) {
	        console.info("PASS! response:%o", response);
	        console.log("status%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body);
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    },
	    updateChart: function updateChart(data) {
	      data = [{ "count": "154", "bedroom": "1" }, { "count": "576", "bedroom": "2" }, { "count": "70", "bedroom": "3" }, { "count": "12", "bedroom": "4" }, { "count": "2", "bedroom": "5" }];
	      console.log("updateChart...data:%o", data);
	      var at = new Array();
	      var as = new Array();
	      var asyncData = {
	        categories: at,
	        data: as
	      };
	
	      for (var x in data) {
	        console.log("x:%s, data:%o", x, data[x]);
	        var tn = data[x]["bedroom"] + "居室";
	        at.push(tn);
	        var ass = '{"value":"' + data[x]["count"] + '","name":"' + tn + '"}';
	        as.push(ass);
	      }
	      console.log("at:%o, as:%o", at, as);
	      console.log("this.$refs.pie:%o", this.$refs.pie);
	
	      return asyncData;
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    console.log("beforeCreate...");
	  },
	  created: function created() {
	    console.log("created...");
	    console.log('get openid:%s', _auth2.default.getOpenid());
	    console.log('get community:%s', _auth2.default.getCm());
	    console.log('get token:%s', _auth2.default.getToken());
	    this.community = _auth2.default.getCm();
	    console.log("community:%s", this.community);
	
	    console.log("this.respData:%o", this.respData);
	  },
	  beforeMount: function beforeMount() {
	    console.log("beforeMount...");
	  },
	  mounted: function mounted() {
	    console.log("mounted...");
	
	    this.load();
	  },
	  beforeUpdate: function beforeUpdate() {
	    console.log("beforeUpdate...");
	  },
	  updated: function updated() {
	    console.log("updated...");
	  },
	  activated: function activated() {
	    console.log("activated...");
	  },
	  deactivated: function deactivated() {
	    console.log("deactivated...");
	  },
	  beforeDestory: function beforeDestory() {
	    console.log("beforeDestory...");
	  },
	  destroyed: function destroyed() {
	    console.log("destroyed...");
	  },
	
	  components: {
	    MainLayout: _Main2.default
	  }
	
	};

/***/ },

/***/ 175:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(20);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _auth = __webpack_require__(16);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log("auth:%o", _auth2.default);
	
	exports.default = {
	  data: function data() {
	    var legend_data = ['1', '2', '3', '4', '5'];
	    var series_data = [{ "value": "154", "name": "1" }, { "value": "576", "name": "2" }, { "value": "70", "name": "3" }, { "value": "12", "name": "4" }, { "value": "2", "name": "5" }];
	
	    return {
	
	      openid: '',
	      token: '',
	      community: '',
	      reqHouseAreaUrl: 'https://alphago.chemucao.cn/real/index.php/community/deal?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&community=',
	      respData: {},
	
	      bar: {
	        title: {
	          text: '异步数据加载示例'
	        },
	        tooltip: {},
	        legend: {
	          data: ['销量']
	        },
	        xAxis: {
	          data: []
	        },
	        yAxis: {},
	        series: [{
	          name: '销量',
	          type: 'bar',
	          data: []
	        }]
	      },
	
	      line: {
	        title: {
	          text: '成交价格',
	          left: 'center',
	          textStyle: {
	            color: '#999'
	          }
	        },
	        tooltip: {
	          trigger: 'axis'
	        },
	        legend: {
	          top: 25,
	          data: ['目标小区', '北京']
	        },
	        grid: {
	          left: '3%',
	          right: '4%',
	          bottom: '3%',
	          containLabel: true
	        },
	        toolbox: {
	          feature: {
	            dataZoom: { yAxisIndex: 'none' },
	            dataView: { readOnly: false },
	            saveAsImage: {}
	          }
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: true,
	          data: []
	        },
	        yAxis: {
	          type: 'value'
	        },
	        series: [{
	          name: '',
	          type: 'line',
	          data: []
	        }, {
	          name: '北京',
	          type: 'line',
	          data: []
	        }]
	      }
	
	    };
	  },
	
	  methods: {
	    load: function load() {
	      console.log("this.respData:%o", this.respData);
	
	      var price = this.respData.price;
	
	      var bj_price = this.respData.bj_price;
	
	      var brief = this.respData.brief;
	
	      console.log("updateChart...price:%o", price);
	      var at = [];
	      var as = [];
	      for (var key in price) {
	        var value = price[key];
	        at.push(key);
	        as.push(price[key]);
	      }
	
	      var bat = [];
	      var bas = [];
	      for (var _key in bj_price) {
	        var _value = bj_price[_key];
	        bat.push(_key);
	        bas.push(bj_price[_key]);
	      }
	
	      var n = [];
	      n.push(brief.name);
	      n.push("北京");
	      console.log("n:%o", n);
	      var asyncData = {
	        name: n,
	        categories: at,
	        data: as
	      };
	
	      var bjasyncData = {
	        categories: bat,
	        data: bas
	      };
	
	      console.log("load...asyncData:%o", asyncData.data);
	      console.log("load...bjasyncData:%o", bjasyncData.data);
	
	      this.$refs.line.mergeOptions({
	        legend: {
	          top: 25,
	          data: asyncData.name
	        },
	        xAxis: {
	          data: asyncData.categories
	        },
	        series: [{
	          name: asyncData.name[0],
	          data: asyncData.data
	        }, {
	          name: "北京",
	          data: bjasyncData.data
	        }]
	      });
	    },
	
	    reqApiData: function reqApiData(community) {
	      var _this = this;
	
	      console.info("community:%s", community);
	      var url = this.reqHouseAreaUrl + community;
	      console.debug("reqHouseArea url:%s", url);
	
	      this.$http.post(url, { foo: "bar" }).then(function (response) {
	        console.info("PASS! response:%o", response);
	        console.log("status%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body);
	        _this.respData = response.body.data;
	        _this.load();
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    },
	    updateChart: function updateChart(data) {
	      data = [{ "count": "154", "bedroom": "1" }, { "count": "576", "bedroom": "2" }, { "count": "70", "bedroom": "3" }, { "count": "12", "bedroom": "4" }, { "count": "2", "bedroom": "5" }];
	      console.log("updateChart...data:%o", data);
	      var at = new Array();
	      var as = new Array();
	      var asyncData = {
	        categories: at,
	        data: as
	      };
	
	      for (var x in data) {
	        console.log("x:%s, data:%o", x, data[x]);
	        var tn = data[x]["bedroom"] + "居室";
	        at.push(tn);
	        var ass = '{"value":"' + data[x]["count"] + '","name":"' + tn + '"}';
	        as.push(ass);
	      }
	      console.log("at:%o, as:%o", at, as);
	      console.log("this.$refs.pie:%o", this.$refs.pie);
	
	      return asyncData;
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    console.log("beforeCreate...");
	  },
	  created: function created() {
	    console.log("created...");
	
	    console.log('get openid:%s', _auth2.default.getOpenid());
	
	    console.log('get token:%s', _auth2.default.getToken());
	    console.log("route.query.cm:%s", this.$route.query.cm);
	    if (typeof this.$route.query.cm != "undefined") {
	      var cm = this.$route.query.cm;
	      console.log("cm:%s", cm);
	      _auth2.default.setCm(cm);
	    }
	    this.community = _auth2.default.getCm();
	    console.log("community:%s", this.community);
	    this.reqApiData(this.community);
	  },
	  beforeMount: function beforeMount() {
	    console.log("beforeMount...");
	  },
	  mounted: function mounted() {
	    console.log("mounted...");
	  },
	  beforeUpdate: function beforeUpdate() {
	    console.log("beforeUpdate...");
	  },
	  updated: function updated() {
	    console.log("updated...");
	  },
	  activated: function activated() {
	    console.log("activated...");
	  },
	  deactivated: function deactivated() {
	    console.log("deactivated...");
	  },
	  beforeDestory: function beforeDestory() {
	    console.log("beforeDestory...");
	  },
	  destroyed: function destroyed() {
	    console.log("destroyed...");
	  },
	
	  components: {
	    MainLayout: _Main2.default
	  }
	
	};

/***/ },

/***/ 176:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Main = __webpack_require__(20);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _auth = __webpack_require__(16);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log("auth:%o", _auth2.default);
	
	exports.default = {
	  data: function data() {
	    return {
	
	      openid: '',
	      token: '',
	      community: '',
	      reqHouseAreaUrl: 'https://alphago.chemucao.cn/real/index.php/community/deal?openid=ocwMjv_FhbsJTkhUNhAU7koY64Ps&token=alphago_admin_debug&community=',
	      respData: {},
	
	      line: {
	        title: {
	          text: '成交价格',
	          left: 'center',
	          textStyle: {
	            color: '#999'
	          }
	        },
	        tooltip: {
	          trigger: 'axis'
	        },
	        legend: {
	          top: 25,
	          data: ['phpdata', '北京']
	        },
	        grid: {
	          left: '3%',
	          right: '4%',
	          bottom: '3%',
	          containLabel: true
	        },
	        toolbox: {
	          feature: {
	            dataZoom: { yAxisIndex: 'none' },
	            dataView: { readOnly: false },
	            saveAsImage: {}
	          }
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: true,
	          data: []
	        },
	        yAxis: {
	          type: 'value'
	        },
	        series: [{
	          name: 'phpdata',
	          type: 'line',
	          data: ['phpdata']
	        }, {
	          name: '北京',
	          type: 'line',
	          data: ['phpdata']
	        }]
	      },
	
	      bar: {
	        title: {
	          text: '成交数量',
	          left: 'center',
	          textStyle: {
	            color: '#999'
	          }
	        },
	        tooltip: {
	          trigger: 'axis'
	        },
	        legend: {
	          top: 25,
	          data: ['phpdata', '北京']
	        },
	        grid: {
	          left: '3%',
	          right: '4%',
	          bottom: '3%',
	          containLabel: true
	        },
	        toolbox: {
	          feature: {
	            dataZoom: { yAxisIndex: 'none' },
	            dataView: { readOnly: false },
	            saveAsImage: {}
	          }
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: true,
	          data: ['phpdata']
	        },
	        yAxis: {
	          type: 'value'
	        },
	        series: [{
	          name: 'phpdata',
	          type: 'bar',
	          data: ['phpdata']
	        }, {
	          name: '北京',
	          type: 'bar',
	          data: ['phpdata']
	        }]
	      },
	
	      pie: {
	        title: {
	          text: '成交户型分布',
	          left: 'center',
	          textStyle: {
	            color: '#999'
	          }
	        },
	        legend: {
	          top: 25,
	          data: ['phpdata', '北京']
	        },
	        toolbox: {
	          feature: {
	            dataZoom: { yAxisIndex: 'none' },
	            dataView: { readOnly: false },
	            saveAsImage: {}
	          }
	        },
	        tooltip: {
	          trigger: 'item',
	          formatter: "{a} <br/>{b} : {c} ({d}%)"
	        },
	        series: [{
	          name: '北京',
	          type: 'pie',
	          radius: '55%',
	          center: ['75%', '50%'],
	          data: ['phpdata'],
	          roseType: 'angle',
	          labelLine: {
	            normal: {
	              lineStyle: {
	                color: 'rgba(2, 2, 30, 0.3)'
	              },
	              smooth: 0.2,
	              length: 10,
	              length2: 20
	            }
	          },
	          itemStyle: {
	            normal: {
	              color: 'rgba(2, 26, 81, 0.8)',
	              shadowBlur: 200,
	              shadowColor: 'rgba(0, 0, 0, 0.5)'
	            }
	          }
	        }, {
	          name: 'phpdata',
	          type: 'pie',
	          radius: '55%',
	          center: ['25%', '50%'],
	          data: ['phpdata'],
	          roseType: 'angle',
	          labelLine: {
	            normal: {
	              lineStyle: {
	                color: 'rgba(2, 2, 30, 0.3)'
	              },
	              smooth: 0.2,
	              length: 10,
	              length2: 20
	            }
	          },
	          itemStyle: {
	            normal: {
	              color: '#c23531',
	              shadowBlur: 200,
	              shadowColor: 'rgba(0, 0, 0, 0.5)'
	            }
	          }
	        }]
	      }
	
	    };
	  },
	
	  methods: {
	    load: function load() {
	      console.log("this.respData:%o", this.respData);
	
	      var bedroom = this.respData.bedroom;
	
	      var bj_bedroom = this.respData.bj_bedroom;
	
	      var brief = this.respData.brief;
	
	      console.log("updateChart...bedroom:%o", bedroom);
	      var at = [];
	      var as = [];
	      for (var key in bedroom) {
	        var name = bedroom[key]['bedroom'] + "居室";
	        var value = bedroom[key]['count'];
	        value = { value: value, name: name };
	        at.push(name);
	        as.push(value);
	        console.log("name:%s, value:%s", name, value);
	      }
	
	      console.log("updateChart...bj_bedroom:%o", bj_bedroom);
	      var bat = [];
	      var bas = [];
	      for (var _key in bj_bedroom) {
	        var _name = bj_bedroom[_key]['bedroom'] + "居室";
	        var _value = bj_bedroom[_key]['count'];
	        _value = { value: _value, name: _name };
	        bat.push(_name);
	        bas.push(_value);
	        console.log("name:%s, value:%s", _name, _value);
	      }
	
	      var n = [];
	      n.push(brief.name);
	      n.push("北京");
	      console.log("n:%o", n);
	      var asyncData = {
	        name: n,
	        categories: at,
	        data: as
	      };
	
	      var bjasyncData = {
	        categories: bat,
	        data: bas
	      };
	
	      console.log("load...asyncData:%o", asyncData);
	      console.log("load...bjasyncData:%o", bjasyncData);
	
	      this.$refs.pie.mergeOptions({
	        legend: {
	          top: 25,
	          data: asyncData.name
	        },
	        series: [{
	          name: asyncData.name[0],
	          data: asyncData.data
	        }, {
	          name: asyncData.name[1],
	          data: bjasyncData.data
	        }]
	      });
	    },
	
	    reqApiData: function reqApiData(community) {
	      var _this = this;
	
	      console.info("community:%s", community);
	      var url = this.reqHouseAreaUrl + community;
	      console.debug("reqHouseArea url:%s", url);
	
	      this.$http.post(url, { foo: "bar" }).then(function (response) {
	        console.info("PASS! response:%o", response);
	        console.log("status%s", response.status);
	        console.log("statusText:%s", response.statusText);
	        console.log("Expires: %s", response.headers.get('Expires'));
	        console.log("body: %o", response.body);
	        _this.respData = response.body.data;
	        _this.load();
	      }, function (response) {
	        console.error("FAIL!!! response:%o", response);
	      });
	    },
	    updateChart: function updateChart(data) {
	      data = [{ "count": "154", "bedroom": "1" }, { "count": "576", "bedroom": "2" }, { "count": "70", "bedroom": "3" }, { "count": "12", "bedroom": "4" }, { "count": "2", "bedroom": "5" }];
	      console.log("updateChart...data:%o", data);
	      var at = new Array();
	      var as = new Array();
	      var asyncData = {
	        categories: at,
	        data: as
	      };
	
	      for (var x in data) {
	        console.log("x:%s, data:%o", x, data[x]);
	        var tn = data[x]["bedroom"] + "居室";
	        at.push(tn);
	        var ass = '{"value":"' + data[x]["count"] + '","name":"' + tn + '"}';
	        as.push(ass);
	      }
	      console.log("at:%o, as:%o", at, as);
	      console.log("this.$refs.pie:%o", this.$refs.pie);
	
	      return asyncData;
	    }
	  },
	  beforeCreate: function beforeCreate() {
	    console.log("beforeCreate...");
	  },
	  created: function created() {
	    console.log("created...");
	    console.log('get openid:%s', _auth2.default.getOpenid());
	    console.log('get community:%s', _auth2.default.getCm());
	    console.log('get token:%s', _auth2.default.getToken());
	    this.community = _auth2.default.getCm();
	    console.log("community:%s", this.community);
	    this.reqApiData(this.community);
	  },
	  beforeMount: function beforeMount() {
	    console.log("beforeMount...");
	  },
	  mounted: function mounted() {
	    console.log("mounted...");
	  },
	  beforeUpdate: function beforeUpdate() {
	    console.log("beforeUpdate...");
	  },
	  updated: function updated() {
	    console.log("updated...");
	  },
	  activated: function activated() {
	    console.log("activated...");
	  },
	  deactivated: function deactivated() {
	    console.log("deactivated...");
	  },
	  beforeDestory: function beforeDestory() {
	    console.log("beforeDestory...");
	  },
	  destroyed: function destroyed() {
	    console.log("destroyed...");
	  },
	
	  components: {
	    MainLayout: _Main2.default
	  }
	
	};

/***/ },

/***/ 177:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  '/': 'Home',
	  '/about': 'About',
	
	  '/price': 'Hprice',
	  '/qty': 'Hdqty',
	  '/type': 'Htype',
	
	  '/detail': 'Detail'
	};

/***/ },

/***/ 178:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(59)
	
	/* script */
	__vue_exports__ = __webpack_require__(169)
	
	/* template */
	var __vue_template__ = __webpack_require__(189)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 179:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(57)
	
	/* script */
	__vue_exports__ = __webpack_require__(170)
	
	/* template */
	var __vue_template__ = __webpack_require__(187)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3de299b3"
	
	module.exports = __vue_exports__


/***/ },

/***/ 180:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(62)
	
	/* script */
	__vue_exports__ = __webpack_require__(172)
	
	/* template */
	var __vue_template__ = __webpack_require__(192)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 181:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(56)
	
	/* script */
	__vue_exports__ = __webpack_require__(173)
	
	/* template */
	var __vue_template__ = __webpack_require__(186)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ff30334"
	
	module.exports = __vue_exports__


/***/ },

/***/ 182:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(55)
	
	/* script */
	__vue_exports__ = __webpack_require__(174)
	
	/* template */
	var __vue_template__ = __webpack_require__(185)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 183:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(58)
	
	/* script */
	__vue_exports__ = __webpack_require__(175)
	
	/* template */
	var __vue_template__ = __webpack_require__(188)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 184:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(61)
	
	/* script */
	__vue_exports__ = __webpack_require__(176)
	
	/* template */
	var __vue_template__ = __webpack_require__(191)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 185:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main-layout', [_c('chart', {
	    ref: "line",
	    attrs: {
	      "options": _vm.line,
	      "theme": "ovilia-green",
	      "auto-resize": ""
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },

/***/ 186:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main-layout', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.community),
	      expression: "community"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "请输入小区名（查询一次仅需1钢蹦）"
	    },
	    domProps: {
	      "value": _vm._s(_vm.community)
	    },
	    on: {
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "enter", 13)) { return; }
	        _vm.submit($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.community = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "glyphicon glyphicon-remove-sign form-control-feedback"
	  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "row marketing"
	  }, [_c('div', {
	    staticClass: "col-lg-6 text-center"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.subtitleMsg))]), _vm._v(" "), _vm._l((_vm.lists), function(item) {
	    return _c('div', {
	      key: item,
	      staticClass: "list-item"
	    }, [_c('span', [_c('router-link', {
	      attrs: {
	        "to": {
	          path: '/detail',
	          query: {
	            cm: item
	          }
	        }
	      }
	    }, [_vm._v("\n              " + _vm._s(item) + "\n              ")])], 1)])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "footer text-center"
	  })])])
	},staticRenderFns: []}

/***/ },

/***/ 187:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    class: {
	      active: _vm.isActive
	    },
	    attrs: {
	      "href": _vm.href
	    },
	    on: {
	      "click": _vm.go
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },

/***/ 188:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main-layout', [_c('chart', {
	    ref: "line",
	    attrs: {
	      "options": _vm.line
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },

/***/ 189:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "echarts"
	  })
	},staticRenderFns: []}

/***/ },

/***/ 190:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ul'), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },

/***/ 191:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main-layout', [_c('chart', {
	    ref: "pie",
	    attrs: {
	      "options": _vm.pie
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },

/***/ 192:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main-layout', [_c('chart', {
	    ref: "bar",
	    attrs: {
	      "options": _vm.bar
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.da4c590656cfb8f661d3.js